module.exports = __webpack_public_path__ + "img/icon_jobs.98304e3c.svg";